<div class="survey__screen survey-msg<%= loading ? ' survey-msg--loading' : '' %>">
  <div class="survey-msg__body" role="<%= loading ? 'status' : 'alert' %>">
    <span class="survey-msg__icon"><i class="icon icon--<%= icon %>"></i></span>
    <h1 class="survey-msg__title"><%= title %></h1>
    <% if ( text ) { %><p class="survey-msg__text"><%= text %></p><% } %>
    <% if ( retry ) { %>
    <button type="button" class="survey__cta" data-action="retry"><%= _lcs( 'Erneut versuchen' ) %></button>
    <% } %>
    <% if ( home ) { %>
    <button type="button" class="survey__cta survey__cta--ghost" data-action="home"><%= _lcs( 'Zur Gäste-App' ) %></button>
    <% } %>
  </div>
</div>
